import { createSlice } from '@reduxjs/toolkit';

export const conferenceBridgeSlice = createSlice({
    name: 'conferencebridge',
    initialState: {
        bridge_adduser_1: [],
        bridge_userList: [],
    },
    reducers: {
        setBridge_adduser_1: (state, action) => {
            state.bridge_adduser_1 = action.payload;
        },
        setBridge_userList: (state, action) => {
            state.bridge_userList = action.payload;
        }
    }
});

export const {
    setBridge_adduser_1,
    setBridge_userList
} = conferenceBridgeSlice.actions

export default conferenceBridgeSlice.reducer;